module.exports = __webpack_public_path__ + "img/Octagon.c6e64e48.svg";